"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RTL 2021 API (2026.08.10.)
 * RTL 2021 API (2026.08.10.)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rtlteam@konzorcia.hu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentListDataFromJSON = ContentListDataFromJSON;
exports.ContentListDataFromJSONTyped = ContentListDataFromJSONTyped;
exports.ContentListDataToJSON = ContentListDataToJSON;
exports.ContentListDataToJSONTyped = ContentListDataToJSONTyped;
const runtime_1 = require("../runtime");
const _1 = require("./");
function ContentListDataFromJSON(json) {
    return ContentListDataFromJSONTyped(json, false);
}
function ContentListDataFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...json,
        'totalCount': !(0, runtime_1.exists)(json, 'totalCount') ? undefined : json['totalCount'],
        'payload': !(0, runtime_1.exists)(json, 'payload') ? undefined : (0, _1.ContentListDataPayloadFromJSON)(json['payload']),
        'items': !(0, runtime_1.exists)(json, 'items') ? undefined : (json['items'].map(_1.MinimalContentDataFromJSON)),
        'filterOptions': !(0, runtime_1.exists)(json, 'filterOptions') ? undefined : (json['filterOptions'].map(_1.FilterOptionsFromJSON)),
    };
}
function ContentListDataToJSON(value) {
    return ContentListDataToJSONTyped(value, false);
}
function ContentListDataToJSONTyped(value, ignoreDiscriminator = false) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...value,
        'totalCount': value.totalCount,
        'payload': (0, _1.ContentListDataPayloadToJSON)(value.payload),
        'items': value.items === undefined ? undefined : (value.items.map(_1.MinimalContentDataToJSON)),
        'filterOptions': value.filterOptions === undefined ? undefined : (value.filterOptions.map(_1.FilterOptionsToJSON)),
    };
}
